import ChatWindow from "./components/ChatWindow";
import "./index.css";

export default function App() {
  return (
    <div className="app-container">
      <header className="header">
        <img src="/logo.png" alt="Logo" className="logo" />
        <h2>Flyline HR Assistant ✈️</h2>
      </header>

      <ChatWindow />

      <footer className="footer">
        © 2025 Flyline Airlines · HR AI Assistant · AIML Oct 2024 Batch
      </footer>
    </div>
  );
}
